// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
//import HomeView from "@/views/HomeView.vue";
import InventoryView from "@/views/InventoryView.vue";
import StatusView from "@/views/StatusView.vue";
import GraphicsView from "@/views/GraphicsView.vue";
import SpecialView from "@/views/SpecialView.vue";
import LogisticsView from "@/views/LogisticsView.vue";
import LoginView from "@/views/LoginView.vue";
import ControlView from "@/views/ControlView.vue";
import TableView from "@/views/TableView.vue";
import { useAuthStore } from "@/stores/authStore";
import ManualesView from "@/views/ManualesView.vue";
import PocStatusView from "@/views/PocStatusView.vue";
import ProfileUpdate from "@/views/ProfileUpdate.vue";
import PanelDispositivos from "@/views/PanelDispositivos.vue";
import PublicView from "@/views/PublicView.vue";
import NewMap from "@/views/NewMap.vue";
import SecretGame from "@/views/SecretGame.vue";
import IncidenciasView from "@/views/IncidenciasView.vue";
import IAView from "@/views/IAView.vue";
// Importa más vistas si las tienes

const routes = [
  {
    path: "/login",
    name: "Login",
    component: LoginView,
  },
  {
    path: "/",
    name: "Home",
    component: NewMap,
    meta: { requiresAuth: true },
  },
  {
    path: "/inventory",
    name: "Inventory",
    component: InventoryView,
    meta: { requiresAuth: true },
  },
  {
    path: "/status",
    name: "Status",
    component: StatusView,
    meta: { requiresAuth: true },
  },
  {
    path: "/graphics",
    name: "Graphics",
    component: GraphicsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/special",
    name: "Special",
    component: SpecialView,
    meta: { requiresAuth: true },
  },
  {
    path: "/Logistics",
    name: "Logistics",
    component: LogisticsView,
    meta: { requiresAuth: true },
  },
  {
    path: "/Control",
    name: "Control",
    component: ControlView,
    meta: { requiresAuth: true },
  },
  {
    path: "/NewData",
    name: "NewData",
    component: TableView,
    meta: { requiresAuth: true },
  },
  {
    path: "/Manuales",
    name: "Manuales",
    component: ManualesView,
    meta: { requiresAuth: false },
  },
  {
    path: "/poc-status",
    name: "PocStatus",
    component: PocStatusView,
    meta: { requiresAuth: true },
  },
  {
    path: "/perfil",
    name: "Perfil",
    component: ProfileUpdate,
    meta: { requiresAuth: true },
  },
  {
    path: "/PanelDisp",
    name: "PanelDispositivos",
    component: PanelDispositivos,
    meta: { requiresAuth: true },
  },
  {
    path: "/Public",
    name: "Public",
    component: PublicView,
    meta: { requiresAuth: false },
  },
  {
    path: "/newMap",
    name: "NewMap",
    component: NewMap,
    meta: { requiresAuth: true },
  },
  {
    path: "/secret",
    name: "SecretGame",
    component: SecretGame,
    meta: { requiresAuth: true },
  },
  {
    path: "/incidencias",
    name: "Incidencias",
    component: IncidenciasView,
    meta: { requiresAuth: true },
  },
  {
    path: "/admin/usuarios",
    name: "AdminUsuarios",
    component: () => import("@/views/AdminUsuariosView.vue"),
    meta: { requiresAuth: true, adminOnly: true },
  },
  {
    path: "/alm_assistant",
    name: "alm_assistant",
    component: IAView,
    meta: { requiresAuth: false },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();
  await authStore.checkAuthentication();

  // Rutas públicas
  const publicPages = ["Login", "Public", "alm_assistant"];

  if (publicPages.includes(to.name)) {
    return next();
  }

  if (!authStore.isAuthenticated) {
    return next({ name: "Login" });
  }

  const empresa = authStore.user?.empresa;

  // Rutas que requieren autenticación
  const allowedForEmpresasRestringidas = [
    "PanelDispositivos",
    "Perfil",
    "Login",
    "Public",
    //"alm_assistant",
  ];
  const empresasRestringidas = [4, 5, 6];

  // Verifica si la empresa del usuario está en la lista de empresas restringidas
  if (
    empresasRestringidas.includes(empresa) &&
    !allowedForEmpresasRestringidas.includes(to.name)
  ) {
    return next({ name: "PanelDispositivos" });
  }

  // Acceso permitido
  next();
});

export default router;
